const pendingRequests = new Map()
const getRequestKey = config => `${config.method}:${config.url}`
export default function (context) {
  let isLoginRoute = false

  // This hideSuccessToast, is used to hide the success message from API response manually
  // To use this, add hideToast: true in the params of the API request
  const utcTime = date => {
    return context
      .$dayjs(date || new Date())
      .utc()
      .format('YYYY-MM-DD HH:mm:ss')
  }

  const setAgentDomainHeader = config => {
    if (process.client) {
      // production
      config.headers.common['agent-domain'] = window?.location?.host
      // testing purposes
      // config.headers.common['agent-domain'] = 'wing90.com'
    }
  }

  const setDateParamsToUTC = config => {
    const params = { ...config.params } || {}
    if (params.start_date) params.start_date = utcTime(params.start_date)
    if (params.end_date) params.end_date = utcTime(params.end_date)
    config.params = params
  }

  context.$axios.onRequest(config => {
    const requestKey = getRequestKey(config)

    // Create temporary cancel token if not already exists
    if (!config.cancelToken) {
      // Create a new cancel token
      const source = context.$axios.CancelToken.source()
      config.cancelToken = source.token
      pendingRequests.set(requestKey, source)
    }
    if (config.url === '/players/login') isLoginRoute = true
    if (context.store.state.auth.rejectAllApiRequests) {
      return Promise.reject(new Error('All requests are blocked'))
    }
    setAgentDomainHeader(config)
    setDateParamsToUTC(config)
    delete config.params.hideToast
    if (process.server) {
      config.headers.origin = `https://${context.app.$config.DOMAIN}`
    }
    config.baseURL = context.app.$config.API_DOMAIN
    if (context.$cookie.get('token')) {
      if (config.headers.common) {
        config.headers.common.Authorization = `${context.$cookie.get('token')}`
      }
    }
  })

  context.$axios.interceptors.response.use(
    response => {
      // Delete the request from the request's token
      const requestKey = getRequestKey(response.config)
      pendingRequests.delete(requestKey)
      const isJSON = response.headers['content-type'].includes('application/json')
      return isJSON ? response : Promise.reject(response)
    },
    error => {
      return retryRequest(error)
    }
  )

  const retryRequest = async error => {
    const { config, message } = error
    if (!config || !config.retry) return Promise.reject(error)

    if (message.includes('timeout') || message.includes('Network Error')) {
      config.retry -= 1
      await new Promise(resolve => setTimeout(resolve, config.retryDelay || 1000))
      return context.$axios(config)
    }
    return Promise.reject(error)
  }

  context.$axios.onError(error => {
    handleError(error)
  })

  const handleError = error => {
    if (process.client) {
      if (error?.response?.status === 302) {
        const redirectUrl = error.response?.data?.redirect || null
        if (redirectUrl) {
          window.location.href = redirectUrl
          return
        }
      }
      try {
        // Since Wrong username and password are also response http = 401
        if (error?.response?.status === 401 && isLoginRoute !== true) {
          try {
            cancelAllRequests()
            showToastMessage(
              context.store.state.themes['language-string'].errorStrings[
                error?.response?.data?.code
              ] ||
                error?.response?.data?.message ||
                'Unauthorized'
            )
            context.store.commit('auth/setRejectAllApiRequests', true)
          } catch (error) {}
        }
      } catch (error) {}
    }
  }

  const showToastMessage = message => {
    context.$toast?.error(message)
  }
}

const cancelAllRequests = () => {
  pendingRequests.forEach(source => source.cancel(''))
  pendingRequests.clear()
}
